import * as React from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Profile from "./Profile";
import Toolbar from "@mui/material/Toolbar";
import useResponsive from "hooks/useResponsive";

interface Props {
  drawerWidth: number;
  toggleDrawer: (
    isOpen: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void;
}

const Navbar: React.FC<Props> = ({ drawerWidth, toggleDrawer }) => {
  return (
    <AppBar
      position="absolute"
      sx={{
        display: "flex",
        width: useResponsive("up", "lg")
          ? `calc(100% - ${drawerWidth}px)`
          : "100%",
        ml: `${drawerWidth}px`,
        border: "none",
        boxShadow: "none",
        height: "92px",
        verticalAlign: "center",
        background: "rgba(255,255,255, 0.2)",
        backdropFilter: "blur(4px)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          margin: "auto",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: useResponsive("up", "lg") ? "end" : "space-between",
          }}
        >
          {useResponsive("up", "lg") ? (
            <></>
          ) : (
            <IconButton onClick={toggleDrawer(true)} size="small">
              <MenuIcon />
            </IconButton>
          )}
          <Profile />
        </Toolbar>
      </Box>
    </AppBar>
  );
};

export default Navbar;
